import { __assign } from "tslib";
import React from 'react';
import IconWrap from '../../IconWrap';
// TODO: for member_subscriptions, this may need a better home than Icons and def need a DS designation
var Tier = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.998 8.051L20.07 18.787A1.453 1.453 0 0118.651 20H5.35c-.695 0-1.292-.51-1.418-1.213L2.008 8.095a.479.479 0 01.374-.56l.042-.005.066-.002c.347 0 .682.128.944.362l4.847 4.317 2.336-8.143c.225-.786 1.027-1.235 1.791-1.003.47.142.837.52.975 1.003l2.336 8.143 4.847-4.317c.219-.195.488-.317.772-.352l.195-.01c.258 0 .467.214.467.48l-.002.043z" }))));
};
Tier.displayName = 'Tier';
export default Tier;
//# sourceMappingURL=Tier.js.map